/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {map} from 'rxjs/operators';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {inject, Injectable} from "@angular/core";
import {APP_CONFIG} from '../app.config';
import {Site} from "../model/Site";
import {Observable} from "rxjs";
import {Location} from "../model/Location";
import {SiteBaseMileage} from "../model/SiteBaseMileage";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class SitesService {

  private readonly sitesUrl: string;

  constructor(private http: HttpClient) {
    this.sitesUrl = inject(APP_CONFIG).baseUrl + '/api/sites';
  }

  getAllSites (): Observable<Site[]> {
    const url = `${this.sitesUrl}/all`;
    return this.http.get(url).pipe(
      map(response => response as Site[] ));
  }

  getAllActivedSites (): Observable<Site[]> {
    const url = `${this.sitesUrl}/active`;
    return this.http.get(url).pipe(
      map(response => response as Site[] ));
  }

  getSite(id: any): Observable<Site> {
    const url = `${this.sitesUrl}/${id}`;
    return this.http.get(url, httpOptions).pipe(
      map(site => site as Site));
  }

  addNew(newSite: Site): Observable<Site> {
    const url = `${this.sitesUrl}`;
    return this.http.post(url, newSite, httpOptions).pipe(
      map( newSite => newSite as Site ));
  }

  updateSite(site: Site): Observable<Site> {
    var url = `${this.sitesUrl}/${site.siteId}`;
    return this.http.put(url, site, httpOptions).pipe(
      map( site => site as Site ));
  }

  getLocationsBySiteId(siteId: number): Observable<Location[]> {
    var url = `${this.sitesUrl}/${siteId}/locations`;
    return this.http.get(url, httpOptions).pipe(
      map( locations => locations as Location[] ));
  }

  getSiteMileageBySiteId(siteId: number): Observable<SiteBaseMileage[]> {
    const url = `${this.sitesUrl}/${siteId}/sitebasemileages`;
    return this.http.get(url, httpOptions).pipe(
      map(response => response as SiteBaseMileage[]));
  }
}
